import { NightsStayRounded, WbSunnyRounded } from '@mui/icons-material';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import PaletteOutlinedIcon from '@mui/icons-material/PaletteOutlined';
import { PopperPlacementType } from '@mui/material';
import { Theme } from '@mui/material/styles';
import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppearanceContext, AuthContext } from '../../contexts';
import AvatarIcon from './AvatarIcon';
import ModalNavBarItem, {
  ButtonModalMenuItem,
} from './MenuItemTypes/ModalNavBarItem';
import ThemeMenuOptions from './ThemeMenuOptions/ThemeMenuOption';

const buttonSx = (theme: Theme) => ({
  color: theme.palette.primary.contrastText,
  backgroundColor: theme.palette.primary.light,
  width: theme.spacing(4),
  height: theme.spacing(4),
  [theme.breakpoints.up('sm')]: {
    width: theme.spacing(4.5),
    height: theme.spacing(4.5),
  },
  '&:hover': {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.dark,
  },
});

const modalPlacement = {
  placement: 'bottom-end' as PopperPlacementType,
};

const themeVariantIcons = {
  dark: {
    name: 'Light Mode',
    icon: <WbSunnyRounded />,
  },
  light: {
    name: 'Dark Mode',
    icon: <NightsStayRounded />,
  },
};

const UserAvatar = () => {
  const authContext = useContext(AuthContext);
  const appearanceContext = useContext(AppearanceContext);

  // const [themeOptions, setThemeOptions] = React.useState<boolean>(true);

  const navigate = useNavigate();

  const modalSubMenu: (false | ButtonModalMenuItem)[] = [
    {
      icon: themeVariantIcons[appearanceContext.themeVariant].icon,
      componentName: themeVariantIcons[appearanceContext.themeVariant].name,
      handleClick: () => appearanceContext.toggleThemeVariant(),
    },
    authContext.hasEnterpriseLicense()
      ? {
          icon: <PaletteOutlinedIcon />,
          componentName: 'Switch Theme',
          customComponent: <ThemeMenuOptions />,
          handleClick: () => ({}),
          // handleClose: () => ({}),
        }
      : false,
    {
      icon: <ExitToAppIcon />,
      componentName: 'Logout',
      handleClick: () => _logout(),
      // handleClick: () => onLogOut(),
    },
  ];

  const _logout = async () => {
    await authContext
      .logout()
      .then(() => {
        navigate('/', { replace: true });
      })
      .catch((err) => {
        throw new Error(err);
      });
  };

  return (
    <ModalNavBarItem
      icon={<AvatarIcon user={authContext.user} />}
      modalMenuItems={modalSubMenu}
      buttonStyle={buttonSx}
      modalProps={modalPlacement}
    />
  );
};

export default UserAvatar;
